module.exports = __webpack_public_path__ + "static/media/ic-arrow-left.cf9731e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-left.svg
// module id = 593
// module chunks = 14